import React from "react";
import { Button } from "reactstrap";
import CustomTooltip from "../Tooltip";
import { useTranslation } from 'react-i18next';

const Index = ({ title, color, ...other }) => {
  const { t } = useTranslation(['configure']);

  return (
    <CustomTooltip title={title || t('Edit')}>
      <Button type="primary" color={color || 'primary'} style={{ padding: 5 }} {...other}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0833 7.43783L12.5417 3.93783L13.7083 2.77116C14.0278 2.45171 14.4203 2.29199 14.8858 2.29199C15.3514 2.29199 15.7436 2.45171 16.0625 2.77116L17.2292 3.93783C17.5486 4.25727 17.7153 4.64283 17.7292 5.09449C17.7431 5.54616 17.5903 5.93144 17.2708 6.25033L16.0833 7.43783ZM14.875 8.66699L6.04167 17.5003H2.5V13.9587L11.3333 5.12533L14.875 8.66699Z"
            fill="white"
          />
        </svg>
      </Button>
    </CustomTooltip>
  );
};

export default Index;
